import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import "./EquipmentsListModal.css";
import { CreateEquipments, CreateScenario } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";
import { useNavigate } from "react-router-dom";
import ErrorToast from "../toasts/ErrorToast";

const ScenarioNameModal = ({ equipment }) => {
  const { setScenarioNameModal, scenarios, setScenarios, setIsLoading } =
    useContext(Context);
  const [scenarioName, setScenarioName] = useState("");
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setScenarioNameModal(modalName);
  }, []);

  const handleAddScenario = () => {
    let name = scenarioName;
    if (scenarioName == "" || scenarioName == null) {
      return ErrorToast("نام سناریو را وارد کنید");
    }

    setIsLoading(true);
    CreateScenario({
      name,
    })
      .then(({ data }) => {
        setScenarios([...scenarios, data.scenario]);
        setScenarioName('');
        closeButton.current.click();
        setIsLoading(false);
      })
      .catch((err) => {});
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="equipmentsName"
      tabIndex="-1"
      aria-labelledby="equipmentsNameLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              انتخاب نام سناریو
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label htmlFor="scenarioName" className="form-label">
                نام سناریو را وارد کنید
              </label>
              <input
                type="text"
                className="form-control"
                id="scenarioName"
                value={scenarioName}
                onChange={(e) => setScenarioName(e.target.value)}
              />
            </div>
            <div>
              {/* <button
                type="button"
                className="btn btn-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                انصراف
              </button> */}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app me-3 mb-2"
              onClick={handleAddScenario}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScenarioNameModal;
